export const useUiStore = defineStore('ui', () => {
  const sidebarIsOpen = ref(true);
  const notificationPanelIsOpen = ref(false);

  function toggleSidebar(forceValue: boolean | undefined = undefined) {
    if (forceValue !== undefined) {
      sidebarIsOpen.value = forceValue;
    } else {
      sidebarIsOpen.value = !sidebarIsOpen.value;
    }
  }

  function toggleNotificationPanel(forceValue: boolean | undefined = undefined) {
    if (forceValue !== undefined) {
      notificationPanelIsOpen.value = forceValue;
    } else {
      notificationPanelIsOpen.value = !notificationPanelIsOpen.value;
    }
  }

  return {
    sidebarIsOpen,
    toggleSidebar,

    notificationPanelIsOpen,
    toggleNotificationPanel,
  };
});
